import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module';
import CheckoutRoutes from './Routes/Routes';

import './Statics/Scss/Styles.scss';
import Hotjar from './Handlers/Hotjar';

import './Helpers/Datadog';
import { createCustomDimension } from './Helpers/CustomDimension';

const App = () => {
    if (!window.dataLayer) window.dataLayer = [];
    createCustomDimension(); // levanta el dataLayer de Google Analytics

    if (!window.hj) Hotjar.HotjarRun();

    ReactGA.initialize(process.env.REACT_APP_GAID);
    TagManager.initialize({ gtmId: process.env.REACT_APP_GTM });

    return (
        <Routes>
            <Route path="/" element={<Navigate to="/proceso-suscripcion" replace />} />
            {CheckoutRoutes.map((route, i) => (
                <Route
                    key={i}
                    path={route.path}
                    element={<route.component />}
                />
            ))}
            <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
    );
};

export default App;
